import React, { useEffect, useState } from "react";
import api from "../admin/api/api";
import { EyeFill, PrinterFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import "./MyOrders.scss";

function MyOrders() {

  const [orders, setOrders] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    getOrders();
  }, []);

  const getOrders = async () => {
    try {
      const response = await api.get(`/Orders/user/${user.userId}`);
      setOrders(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="orders-container container">

      <h2 className="border-bottom border-2 pb-3">My Orders</h2>

      {orders.length === 0 ? (

        <p>No orders found</p>

      ) : (
        <>

          {/* Desktop Table */}
          <div className="orders-table-wrapper">
            <table className="orders-table">

              <thead>
                <tr>
                  <th>Order No</th>
                  <th>Date</th>
                  <th>Total</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>

                {orders.map((order) => (

                  <tr key={order.orderId}>

                    <td>{order.orderNo}</td>

                    <td>
                      {new Date(order.orderDate).toLocaleDateString()}
                    </td>

                    <td>₹{order.totalAmount}</td>

                    <td>
                      <span className={`status ${order.status.toLowerCase()}`}>
                        {order.status}
                      </span>
                    </td>

                    <td className="actions">

                      <Link to={`/order-details/${order.orderId}`}>
                        <EyeFill />
                      </Link>

                      <Link to={`/invoice/${order.orderId}`}>
                        <PrinterFill />
                      </Link>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>
          </div>


          {/* Mobile Cards */}
          <div className="orders-cards">

            {orders.map((order) => (

              <div key={order.orderId} className="order-card">

                <div className="order-row">
                  <span className="label">Order No</span>
                  <span>{order.orderNo}</span>
                </div>

                <div className="order-row">
                  <span className="label">Date</span>
                  <span>
                    {new Date(order.orderDate).toLocaleDateString()}
                  </span>
                </div>

                <div className="order-row">
                  <span className="label">Total</span>
                  <span>₹{order.totalAmount}</span>
                </div>

                <div className="order-row">
                  <span className="label">Status</span>

                  <span className={`status ${order.status.toLowerCase()}`}>
                    {order.status}
                  </span>
                </div>

                <div className="order-actions">

                  <Link to={`/order-details/${order.orderId}`}>
                    <EyeFill /> View
                  </Link>

                  <Link to={`/invoice/${order.orderId}`}>
                    <PrinterFill /> Invoice
                  </Link>

                </div>

              </div>

            ))}

          </div>

        </>
      )}

    </div>
  );
}

export default MyOrders;